import {
  SAVE, CREATE, UPDATE, DELETE
} from 'src/store/actions/requestSubTypesActions';

const initialState = {
  list: null // null || array
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE: {
      return { ...state, list: action.payload };
    }
    case CREATE: {
      return { ...state, list: (state.list || []).concat(action.payload) };
    }
    case UPDATE: {
      return ({
        ...state,
        list: state.list
          ? state.list.map((entry) => {
            if (entry.Id === action.payload.Id) return action.payload;
            else return entry;
          })
          : [action.payload]
      });
    }
    case DELETE: {
      return { ...state, list: state.list.filter((entry) => entry.Id !== action.payload) };
    }
    default: {
      return state;
    }
  }
};
